import { useState } from "react";
import { Preloader } from "@/components/site/Preloader";
import { ScrollProgress } from "@/components/site/ScrollProgress";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { CaseStudies } from "@/components/site/CaseStudies";
import { Testimonials } from "@/components/site/Testimonials";
import { Authority } from "@/components/site/Authority";
import { ManifestoBand } from "@/components/site/ManifestoBand";
import { WholeEngine } from "@/components/site/WholeEngine";
import { AiAgents } from "@/components/site/AiAgents";
import { HowItWorks } from "@/components/site/HowItWorks";
import { CostCompare } from "@/components/site/CostCompare";
import { Pricing } from "@/components/site/Pricing";
import { Founder } from "@/components/site/Founder";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Faq } from "@/components/site/Faq";
import { FinalCta } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { MobileCta } from "@/components/site/MobileCta";

export default function Landing() {
  const [ready, setReady] = useState(false);

  return (
    <>
      <Preloader onComplete={() => setReady(true)} />
      <ScrollProgress />
      <main className="bg-paper text-ink" data-testid="landing-page">
        <Nav />
        {/* 1. Offer */}
        <Hero ready={ready} />
        {/* 2. What we do */}
        <Services />
        {/* 3. Proof */}
        <CaseStudies />
        {/* 4. Social proof */}
        <Testimonials />
        {/* 5. Guarantee / who it's for */}
        <Authority />
        {/* 6. Commercial journey */}
        <HowItWorks />
        {/* 7. What you buy */}
        <ManifestoBand />
        {/* 8. People, creativity, whole engine */}
        <WholeEngine />
        {/* 9. AI agent infrastructure */}
        <AiAgents />
        {/* 10. Cost of alternatives */}
        <CostCompare />
        {/* 11. Scale options */}
        <Pricing />
        {/* 12. Founder */}
        <Founder />
        <EditorialMarquee />
        <Faq />
        <FinalCta />
        <Footer />
      </main>
      <MobileCta />
    </>
  );
}
